export const roles = {
  ADMIN: 1,
  SUBADMIN: 2,
  USER: 3,
  VENDOR: 4,
  CORPORATE_ORGANISATION: 5,
  SUBVENDOR: 6,
  SUBCORPORATE: 7,
  DRIVER: 8,
  EMPLOYEE: 9,
  CLIENT: 10
};

export const documentTypes = {
  Document: 1,
  KYC: 2
};
